import React from 'react';
import { useParams } from 'react-router-dom';

import {
  useGetAcademyTopicQuery,
  useGetPlaylistContentQuery,
} from 'features/classCreation';
import PlaylistValidatorTabs from './PlaylistValidatorTabs';
import IngestButton from './IngestButton';
import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import SectionHeading from 'components/SectionHeading';
import styles from './EditClassPlaylistPage.module.scss';

function EditClassPlaylistPage() {
  const { academyTopicId } = useParams();
  const {
    isLoading: isAcademyTopicLoading,
    error: academyTopicError,
    data: academyTopic,
    isSuccess,
    refetch,
  } = useGetAcademyTopicQuery(Number(academyTopicId));

  const { isLoading: isPlaylistContentLoading, data: playlistContent } =
    useGetPlaylistContentQuery(
      academyTopic?.data?.playlist_owner?.playlist_id,
      {
        skip: !isSuccess || !academyTopic?.data?.playlist_owner,
      }
    );

  if (isAcademyTopicLoading || isPlaylistContentLoading) {
    return <Loader />;
  } else if (academyTopicError) {
    return (
      <ErrorLayout
        title="Failed to load class details"
        message={
          academyTopicError.data?.message ||
          'Something went wrong! Try again later'
        }
        actionFn={refetch}
      />
    );
  } else {
    const { data: academyTopicData } = academyTopic || {};
    const { title } = academyTopicData || {};
    const { data: playlistContentData } = playlistContent || {};
    const { name } = playlistContentData || {};
    const playlistName = name || title;

    return (
      <div className="p-l">
        <SectionHeading
          title="CUE CARD VALIDATOR"
          subtitle="Create, verify & edit cue card playlists"
        />
        <div className={styles.playlistName}>{playlistName}</div>
        <PlaylistValidatorTabs playlist={playlistContentData} />
        <IngestButton
          academyTopic={academyTopicData}
          playlist={playlistContentData}
        />
      </div>
    );
  }
}

export default EditClassPlaylistPage;
